import {
  getPurchaseActiveBonuses,
  getPurchaseBonusCost,
  getPurchaseBonusPercent,
  getPurchaseCashMachine,
  getPurchaseCreationDate,
  getPurchaseCustomer,
  getPurchaseFiscalId,
  getPurchaseId,
  getPurchaseMoneyCost,
  getPurchasePendingBonuses,
  getPurchaseReceipt,
  getPurchaseRefundBonusCost,
  getPurchaseRefundMoneyCost,
  getPurchaseStatus,
  getPurchaseStoreName,
  getPurchaseTotalCost,
} from '@esentai/core/features/purchases/selectors';
import { withStyles } from '@material-ui/core';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import Row from './component';
import styles from './styles';

const mapStateToProps = (state, { item: purchaseId }) => ({
  activeBonuses: getPurchaseActiveBonuses(state, purchaseId),
  pendingBonuses: getPurchasePendingBonuses(state, purchaseId),
  uuid: getPurchaseFiscalId(state, purchaseId),
  receipt: getPurchaseReceipt(state, purchaseId),
  customer: getPurchaseCustomer(state, purchaseId),
  status: getPurchaseStatus(state, purchaseId),
  date: getPurchaseCreationDate(state, purchaseId),
  totalCost: getPurchaseTotalCost(state, purchaseId),
  purchaseId: getPurchaseId(state, purchaseId),
  storeName: getPurchaseStoreName(state, purchaseId),
  cashMachine: getPurchaseCashMachine(state, purchaseId),
  bonusPercent: getPurchaseBonusPercent(state, purchaseId),
  refundBonusCost: getPurchaseRefundBonusCost(state, purchaseId),
  refundMoneyCost: getPurchaseRefundMoneyCost(state, purchaseId),
  bonusCost: getPurchaseBonusCost(state, purchaseId),
  moneyCost: getPurchaseMoneyCost(state, purchaseId),
});

export default compose(connect(mapStateToProps), withStyles(styles))(Row);
